export function createRelationObj<T extends { [key: string]: string }>(
	obj: T,
	relations: [from: string, to: string][]
): T {
	relations.forEach(([from, to]) => {
		Object.defineProperty(obj, from, {
			configurable: true,
			get() {
				return this[to]
			},
		})
	})

	return obj
}
